<template>
  <div
    id="file-directory-dashboard"
    :class="{
      fullscreen: isFeatureFullscreen && !mobileScreen,
      mobile: mobileScreen
    }"
  >
    <DirectoryNavigation
      :fullscreen="isFeatureFullscreen"
      show-search
      show-breadcrumbs
      show-toolbar
      drag-drop-enabled
      multi-select-enabled
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useGeneralStore } from '@/pinia'
import { useStore } from 'vuex'
import DirectoryNavigation from './DirectoryNavigation.vue'

type Props = {
  title?: string //this prop was added to remove weird hover text in the browser
}
defineProps<Props>()

const piniaStore = useGeneralStore()
const vuexStore = useStore()

const isFeatureFullscreen = computed(() => piniaStore.isFeatureFullscreen)
const mobileScreen = computed(() => vuexStore.state.mobileScreen)
</script>

<style lang="scss" scoped>
@use '@/design-system/design-tokens/font-mixins';
@use '@/design-system/design-tokens/variables.scss';

#file-directory-dashboard {
  background-color: #fff;
  border-bottom-right-radius: variables.$border-radius-small;
  border-bottom-left-radius: variables.$border-radius-small;
  display: flex;
  flex-flow: column;
  height: calc(100vh - #{variables.$layout-top-bar-height} - #{variables.$padding-xlarge} - 152px);
  min-height: 400px;
  overflow: hidden;
  width: 100%;

  &.fullscreen {
    border-radius: 0;
    height: 100%;
    max-height: 100%;
  }

  &.mobile {
    border-radius: 0;
    bottom: 0;
    height: 100%;
    left: 0;
    position: fixed;
    right: 0;
    top: calc(#{variables.$layout-top-bar-height} + 56px);
    max-height: calc(100vh - #{variables.$layout-top-bar-height} - 56px);
    width: 100%;
  }
}
</style>
